var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJaneStreet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsx: "ns_extend;",
    xmlnsi: "ns_ai;",
    xmlnsgraph: "ns_graphs;",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomleftorigin: "true",
    height: 80,
    width: 80,
    x: 2.6,
    y: -264.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8,55.9c5.5,9.4,15.7,15.6,27.3,15.6c17.4,0,31.5-14.2,31.4-31.6c0-17.4-14.2-31.5-31.6-31.4C22.6,8.6,8.5,22.7,8.5,40.1c0,2.1,0.2,4.2,0.6,6.2c0.1,0.3,0.3,0.4,0.6,0.3l4.4-1.1c0.3-0.1,0.4-0.3,0.4-0.6h0c-0.3-1.6-0.5-3.2-0.5-4.9C14,25.7,25.6,14,39.9,14C54.3,14,66,25.6,66,39.9C66,54.3,54.4,66,40.1,66c-9.5,0-17.8-5.1-22.4-12.7c-0.1-0.2-0.4-0.3-0.6-0.2l-4,2.1C12.8,55.4,12.7,55.7,12.8,55.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6,46.8l4,2.1c0.2,0.1,0.6,0,0.7-0.2c1.1-2.6,1.7-5.5,1.7-8.6C63.1,27.5,52.9,17.2,40.2,17H40c-12.6,0-22.9,10.2-23,22.8C16.9,52.5,27.1,62.9,39.8,63l0.2,0c6,0,11.5-2.3,15.6-6.1c0.2-0.2,0.2-0.5,0.1-0.7l-3.4-3.1c-0.2-0.2-0.5-0.1-0.7,0l0,0c-3.1,2.7-7.1,4.4-11.5,4.4l-0.1,0c-9.6-0.1-17.4-8-17.3-17.6c0.1-9.6,7.9-17.3,17.5-17.3h0.2c9.6,0.1,17.4,8,17.3,17.6c0,2.1-0.4,4.1-1.1,6C56.3,46.4,56.3,46.7,56.6,46.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1,7.4c-0.2-0.1-0.5-0.1-0.7,0.1l-2.6,3.7c-0.1,0.2-0.1,0.5,0.1,0.7c8.8,6.3,14.5,16.5,14.5,28.1c0,19-15.5,34.5-34.5,34.5C21,74.5,5.5,59,5.5,40C5.5,21,21,5.5,40,5.5c4.1,0,8.1,0.7,11.8,2.1v0c0.2,0.1,0.5,0,0.6-0.3L54,3.1c0.1-0.2,0-0.5-0.3-0.6C49.5,0.9,44.9,0,40,0C18,0,0,17.9,0,40c0,22.1,18,40,40,40c22.1,0,40-17.9,40-40C80,26.6,73.4,14.6,63.1,7.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJaneStreet);
export default __webpack_public_path__ + "static/media/icon-jane-street.550cc384a71e9fa4243210e513fda034.svg";
export { ForwardRef as ReactComponent };